import { defineMessages } from 'react-intl';

export default defineMessages({
    edit: {
        id: 'ml.quoteandbind.pup.vehicleTable.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.pup.vehicleTable.remove',
        defaultMessage: 'Remove'
    },
    type: {
        id: 'ml.quoteandbind.pup.vehicleTable.type',
        defaultMessage: 'TYPE'
    },
    year: {
        id: 'ml.quoteandbind.pup.vehicleTable.year',
        defaultMessage: 'YEAR'
    },
    make: {
        id: 'ml.quoteandbind.pup.vehicleTable.make',
        defaultMessage: 'MAKE'
    },
    model: {
        id: 'ml.quoteandbind.pup.vehicleTable.model',
        defaultMessage: 'MODEL'
    },
    vin: {
        id: 'ml.quoteandbind.pup.vehicleTable.vin',
        defaultMessage: 'VIN'
    },
    excluded: {
        id: 'ml.quoteandbind.pup.vehicleTable.excluded',
        defaultMessage: 'EXCLUDED'
    },
    noInfoExists: {
        id: 'ml.quoteandbind.pup.vehicleTable.noInfoExists',
        defaultMessage: 'No Information Exists'
    },
    yes: {
        id: 'ml.quoteandbind.pup.vehicleTable.yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'ml.quoteandbind.pup.vehicleTable.no',
        defaultMessage: 'No'
    },
    watercraft: {
        id: 'ml.quoteandbind.pup.vehicleTable.watercraft',
        defaultMessage: 'Watercraft'
    },
    vehicles: {
        id: 'ml.quoteandbind.pup.vehicleTable.vehicles',
        defaultMessage: 'Vehicles'
    },
    addWatercraft: {
        id: 'ml.quoteandbind.pup.vehicleTable.addWatercraft',
        defaultMessage: 'ADD WATERCRAFT'
    },
    addVehicle: {
        id: 'ml.quoteandbind.pup.vehicleTable.addVehicle',
        defaultMessage: 'ADD VEHICLE'
    }
});
